// Import Types
import type { BudgetGroupName, BudgetHistoryListItem, DataWithPaging } from 'types';
// Import Helpers
import { generateCleanUrlParams } from 'services/Helpers';
// Import Configs
import { CRMRequestService, postCancelableRequest } from './http.config';
import { PromotionTypeEnum } from 'enums';

interface GetBudgetHistoryListRequestParams {
    promotionId: string | number;
    promotionType: PromotionTypeEnum;
    withTotalCount?: boolean;
}

const BudgetHttpService = {
    getBudgetHistoryList: () => {
        return postCancelableRequest<DataWithPaging<BudgetHistoryListItem>, GetBudgetHistoryListRequestParams>({
            requestService: CRMRequestService,
            endpointPath: ({ promotionId, promotionType, withTotalCount }) =>
                `/BudgetHistory/List${generateCleanUrlParams({
                    promotionId,
                    promotionType,
                    withTotalCount,
                })}`,
        });
    },
    getBudgetsGroupNamesList: () => {
        return postCancelableRequest<BudgetGroupName[]>({
            requestService: CRMRequestService,
            endpointPath: ({ promotionId, promotionType }) =>
                `/BudgetHistory/GroupNames${generateCleanUrlParams({
                    promotionId,
                    promotionType,
                })}`,
        });
    },
};

export default BudgetHttpService;
